import SliderSection from './SliderSection';

export default SliderSection;
